import { render, staticRenderFns } from "./ApprovedBusinessesTable.vue?vue&type=template&id=0c016587&scoped=true&"
import script from "./ApprovedBusinessesTable.vue?vue&type=script&lang=ts&"
export * from "./ApprovedBusinessesTable.vue?vue&type=script&lang=ts&"
import style0 from "./ApprovedBusinessesTable.vue?vue&type=style&index=0&id=0c016587&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c016587",
  null
  
)

export default component.exports